/* src\modules\kjells.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	add_flush_callback,
	add_render_callback,
	add_resize_listener,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import '../include/app.css';
import '../include/kjells.css';
import { createEventDispatcher, onMount } from '../../_snowpack/pkg/svelte.js';

import {
	getFirestore,
	doc,
	getDoc,
	getDocs,
	query as fsQuery,
	where as fsWhere,
	collection
} from "../../_snowpack/pkg/firebase/firestore.js";

import InputField from '../components/pixel/inputField.svelte.js';
import Checkbox from '../components/pixel/checkbox.svelte.js';
import axios from '../../_snowpack/pkg/axios.js';
import Dialog from '../components/pixel/dialog.svelte.js';
import _ from '../../_snowpack/pkg/lodash.js';

function create_if_block_6(ctx) {
	let div4;
	let form_1;
	let t0;
	let div0;
	let input0;
	let input0_checked_value;
	let t1;
	let label0;
	let t3;
	let input1;
	let input1_checked_value;
	let t4;
	let label1;
	let t6;
	let inputfield0;
	let t7;
	let inputfield1;
	let t8;
	let div1;
	let inputfield2;
	let t9;
	let inputfield3;
	let t10;
	let inputfield4;
	let t11;
	let div2;
	let show_if = !/*products*/ ctx[0] || /*products*/ ctx[0].indexOf("Solskjerming,Garasjeport") > -1;
	let t12;
	let inputfield5;
	let t13;
	let form_1_resize_listener;
	let t14;
	let div3;
	let button;
	let t15;
	let span;
	let t17;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*formOnly*/ ctx[1] === false && create_if_block_11(ctx);

	let inputfield0_props = {
		placeholder: "Navn*",
		name: "name",
		autocomplete: "name",
		required: true,
		darkMode: false,
		icon: null
	};

	inputfield0 = new InputField({ props: inputfield0_props });
	/*inputfield0_binding*/ ctx[35](inputfield0);
	inputfield0.$on("focus", /*focus_handler_2*/ ctx[36]);

	let inputfield1_props = {
		placeholder: "Adresse*",
		name: "address",
		required: true,
		autocomplete: "address",
		darkMode: false,
		icon: null
	};

	inputfield1 = new InputField({ props: inputfield1_props });
	/*inputfield1_binding*/ ctx[37](inputfield1);
	inputfield1.$on("change", /*change_handler_2*/ ctx[38]);
	inputfield1.$on("focus", /*focus_handler_3*/ ctx[39]);

	let inputfield2_props = {
		placeholder: "Postnummer*",
		name: "postalcode",
		required: true,
		autocomplete: "postal-code",
		darkMode: false,
		icon: null,
		classes: "postalcode",
		style: "width:50%",
		maxlength: "4",
		numbersOnly: true
	};

	inputfield2 = new InputField({ props: inputfield2_props });
	/*inputfield2_binding*/ ctx[40](inputfield2);
	inputfield2.$on("change", /*change_handler_3*/ ctx[41]);
	inputfield2.$on("focus", /*focus_handler_4*/ ctx[42]);

	let inputfield3_props = {
		placeholder: "Telefon*",
		type: "tel",
		name: "tel",
		required: true,
		autocomplete: "tel",
		darkMode: false,
		icon: null,
		classes: "postalcode",
		style: "width:50%;margin-left:10px"
	};

	inputfield3 = new InputField({ props: inputfield3_props });
	/*inputfield3_binding*/ ctx[43](inputfield3);
	inputfield3.$on("change", /*change_handler_4*/ ctx[44]);
	inputfield3.$on("focus", /*focus_handler_5*/ ctx[45]);

	let inputfield4_props = {
		placeholder: "Epost*",
		type: "email",
		name: "email",
		required: true,
		autocomplete: "email",
		darkMode: false,
		icon: null
	};

	inputfield4 = new InputField({ props: inputfield4_props });
	/*inputfield4_binding*/ ctx[46](inputfield4);
	inputfield4.$on("focus", /*focus_handler_6*/ ctx[47]);
	let if_block1 = show_if && create_if_block_10(ctx);

	let inputfield5_props = {
		placeholder: "Ønsker du å legge til mer informasjon? Skriv mer her",
		type: "textarea",
		rows: 2,
		name: "info",
		darkMode: false,
		icon: null
	};

	inputfield5 = new InputField({ props: inputfield5_props });
	/*inputfield5_binding*/ ctx[52](inputfield5);
	inputfield5.$on("focus", /*focus_handler_9*/ ctx[53]);
	let if_block2 = useDiscountCode && create_if_block_9(ctx);
	let if_block3 = /*saving*/ ctx[2] && create_if_block_8(ctx);
	let if_block4 = /*formOnly*/ ctx[1] === false && create_if_block_7(ctx);

	return {
		c() {
			div4 = element("div");
			form_1 = element("form");
			if (if_block0) if_block0.c();
			t0 = space();
			div0 = element("div");
			input0 = element("input");
			t1 = space();
			label0 = element("label");
			label0.textContent = "Privat";
			t3 = space();
			input1 = element("input");
			t4 = space();
			label1 = element("label");
			label1.textContent = "Bedrift";
			t6 = space();
			create_component(inputfield0.$$.fragment);
			t7 = space();
			create_component(inputfield1.$$.fragment);
			t8 = space();
			div1 = element("div");
			create_component(inputfield2.$$.fragment);
			t9 = space();
			create_component(inputfield3.$$.fragment);
			t10 = space();
			create_component(inputfield4.$$.fragment);
			t11 = space();
			div2 = element("div");
			if (if_block1) if_block1.c();
			t12 = space();
			create_component(inputfield5.$$.fragment);
			t13 = space();
			if (if_block2) if_block2.c();
			t14 = space();
			div3 = element("div");
			button = element("button");
			if (if_block3) if_block3.c();
			t15 = space();
			span = element("span");
			span.textContent = "Få uforpliktende tilbud";
			t17 = space();
			if (if_block4) if_block4.c();
			attr(input0, "id", "first");
			attr(input0, "type", "radio");
			attr(input0, "name", "segment");
			input0.value = "privat";
			input0.checked = input0_checked_value = /*data*/ ctx[19].segment === "privat";
			attr(label0, "for", "first");
			attr(input1, "id", "second");
			attr(input1, "type", "radio");
			attr(input1, "name", "segment");
			input1.value = "bedrift";
			set_style(input1, "margin-right", "4px");
			input1.checked = input1_checked_value = /*data*/ ctx[19].segment === "bedrift";
			attr(label1, "for", "second");
			attr(div0, "class", "radio");
			set_style(div0, "display", "flex");
			set_style(div0, "justify-content", "space-between");
			set_style(div0, "width", "100%");
			set_style(div0, "padding-bottom", "10px");
			set_style(div0, "font-size", "15px");
			set_style(div1, "display", "flex");
			set_style(div1, "width", "100%");
			set_style(div2, "display", "flex");
			set_style(div2, "width", "100%");
			set_style(div2, "justify-content", "space-between");
			set_style(div2, "padding-top", "6px");
			set_style(div2, "padding-bottom", "10px");
			set_style(form_1, "padding", "10px");
			add_render_callback(() => /*form_1_elementresize_handler*/ ctx[56].call(form_1));
			set_style(span, "padding-left", "5px");
			set_style(button, "display", "flex");
			set_style(button, "justify-content", "center");
			button.disabled = /*saving*/ ctx[2];
			set_style(div3, "padding-left", "10px");
			set_style(div3, "padding-right", "10px");
			set_style(div3, "padding-bottom", "4px");
			attr(div4, "class", "formcontainer");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, form_1);
			if (if_block0) if_block0.m(form_1, null);
			append(form_1, t0);
			append(form_1, div0);
			append(div0, input0);
			/*input0_binding*/ ctx[30](input0);
			append(div0, t1);
			append(div0, label0);
			append(div0, t3);
			append(div0, input1);
			/*input1_binding*/ ctx[33](input1);
			append(div0, t4);
			append(div0, label1);
			append(form_1, t6);
			mount_component(inputfield0, form_1, null);
			append(form_1, t7);
			mount_component(inputfield1, form_1, null);
			append(form_1, t8);
			append(form_1, div1);
			mount_component(inputfield2, div1, null);
			append(div1, t9);
			mount_component(inputfield3, div1, null);
			append(form_1, t10);
			mount_component(inputfield4, form_1, null);
			append(form_1, t11);
			append(form_1, div2);
			if (if_block1) if_block1.m(div2, null);
			append(form_1, t12);
			mount_component(inputfield5, form_1, null);
			append(form_1, t13);
			if (if_block2) if_block2.m(form_1, null);
			/*form_1_binding*/ ctx[55](form_1);
			form_1_resize_listener = add_resize_listener(form_1, /*form_1_elementresize_handler*/ ctx[56].bind(form_1));
			append(div4, t14);
			append(div4, div3);
			append(div3, button);
			if (if_block3) if_block3.m(button, null);
			append(button, t15);
			append(button, span);
			append(div3, t17);
			if (if_block4) if_block4.m(div3, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input0, "change", /*change_handler*/ ctx[29]),
					listen(input0, "focus", /*focus_handler*/ ctx[31]),
					listen(input1, "change", /*change_handler_1*/ ctx[32]),
					listen(input1, "focus", /*focus_handler_1*/ ctx[34]),
					listen(form_1, "input", /*input_handler*/ ctx[57]),
					listen(button, "click", /*click_handler_1*/ ctx[58])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*formOnly*/ ctx[1] === false) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_11(ctx);
					if_block0.c();
					if_block0.m(form_1, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty[0] & /*data*/ 524288 && input0_checked_value !== (input0_checked_value = /*data*/ ctx[19].segment === "privat")) {
				input0.checked = input0_checked_value;
			}

			if (!current || dirty[0] & /*data*/ 524288 && input1_checked_value !== (input1_checked_value = /*data*/ ctx[19].segment === "bedrift")) {
				input1.checked = input1_checked_value;
			}

			const inputfield0_changes = {};
			inputfield0.$set(inputfield0_changes);
			const inputfield1_changes = {};
			inputfield1.$set(inputfield1_changes);
			const inputfield2_changes = {};
			inputfield2.$set(inputfield2_changes);
			const inputfield3_changes = {};
			inputfield3.$set(inputfield3_changes);
			const inputfield4_changes = {};
			inputfield4.$set(inputfield4_changes);
			if (dirty[0] & /*products*/ 1) show_if = !/*products*/ ctx[0] || /*products*/ ctx[0].indexOf("Solskjerming,Garasjeport") > -1;

			if (show_if) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*products*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_10(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div2, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			const inputfield5_changes = {};
			inputfield5.$set(inputfield5_changes);
			if (useDiscountCode) if_block2.p(ctx, dirty);

			if (/*saving*/ ctx[2]) {
				if (if_block3) {
					
				} else {
					if_block3 = create_if_block_8(ctx);
					if_block3.c();
					if_block3.m(button, t15);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (!current || dirty[0] & /*saving*/ 4) {
				button.disabled = /*saving*/ ctx[2];
			}

			if (/*formOnly*/ ctx[1] === false) {
				if (if_block4) {
					
				} else {
					if_block4 = create_if_block_7(ctx);
					if_block4.c();
					if_block4.m(div3, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(inputfield0.$$.fragment, local);
			transition_in(inputfield1.$$.fragment, local);
			transition_in(inputfield2.$$.fragment, local);
			transition_in(inputfield3.$$.fragment, local);
			transition_in(inputfield4.$$.fragment, local);
			transition_in(if_block1);
			transition_in(inputfield5.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inputfield0.$$.fragment, local);
			transition_out(inputfield1.$$.fragment, local);
			transition_out(inputfield2.$$.fragment, local);
			transition_out(inputfield3.$$.fragment, local);
			transition_out(inputfield4.$$.fragment, local);
			transition_out(if_block1);
			transition_out(inputfield5.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div4);
			if (if_block0) if_block0.d();
			/*input0_binding*/ ctx[30](null);
			/*input1_binding*/ ctx[33](null);
			/*inputfield0_binding*/ ctx[35](null);
			destroy_component(inputfield0);
			/*inputfield1_binding*/ ctx[37](null);
			destroy_component(inputfield1);
			/*inputfield2_binding*/ ctx[40](null);
			destroy_component(inputfield2);
			/*inputfield3_binding*/ ctx[43](null);
			destroy_component(inputfield3);
			/*inputfield4_binding*/ ctx[46](null);
			destroy_component(inputfield4);
			if (if_block1) if_block1.d();
			/*inputfield5_binding*/ ctx[52](null);
			destroy_component(inputfield5);
			if (if_block2) if_block2.d();
			/*form_1_binding*/ ctx[55](null);
			form_1_resize_listener();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (272:16) {#if formOnly === false}
function create_if_block_11(ctx) {
	let div1;
	let div0;
	let t1;
	let if_block = /*noServiceLink*/ ctx[3] === false && create_if_block_12(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			div0.textContent = "Bestill GRATIS befaring";
			t1 = space();
			if (if_block) if_block.c();
			set_style(div0, "font-size", "18px");
			set_style(div0, "font-weight", "600");
			set_style(div0, "padding-bottom", "8px");
			set_style(div0, "text-align", "center");
			set_style(div1, "padding-bottom", "10px");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div1, t1);
			if (if_block) if_block.m(div1, null);
		},
		p(ctx, dirty) {
			if (/*noServiceLink*/ ctx[3] === false) {
				if (if_block) {
					
				} else {
					if_block = create_if_block_12(ctx);
					if_block.c();
					if_block.m(div1, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
		}
	};
}

// (275:24) {#if noServiceLink === false}
function create_if_block_12(ctx) {
	let div;

	return {
		c() {
			div = element("div");

			div.innerHTML = `Gjelder det deler, service eller reklamasjon? 
                                <a href="https://hdsolservice.lets-config.com/reklamasjon" target="_blank" rel="noreferrer">klikk her</a>`;

			set_style(div, "font-size", "15px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (301:20) {#if !products || products.indexOf("Solskjerming,Garasjeport") > -1}
function create_if_block_10(ctx) {
	let checkbox0;
	let updating_checked;
	let t;
	let checkbox1;
	let updating_checked_1;
	let current;

	function checkbox0_checked_binding(value) {
		/*checkbox0_checked_binding*/ ctx[48](value);
	}

	let checkbox0_props = { text: "Solskjerming" };

	if (/*data*/ ctx[19].solskjerming !== void 0) {
		checkbox0_props.checked = /*data*/ ctx[19].solskjerming;
	}

	checkbox0 = new Checkbox({ props: checkbox0_props });
	binding_callbacks.push(() => bind(checkbox0, 'checked', checkbox0_checked_binding));
	checkbox0.$on("focus", /*focus_handler_7*/ ctx[49]);

	function checkbox1_checked_binding(value) {
		/*checkbox1_checked_binding*/ ctx[50](value);
	}

	let checkbox1_props = {
		text: "Garasjeport",
		style: "margin-right:4px"
	};

	if (/*data*/ ctx[19].garasjeport !== void 0) {
		checkbox1_props.checked = /*data*/ ctx[19].garasjeport;
	}

	checkbox1 = new Checkbox({ props: checkbox1_props });
	binding_callbacks.push(() => bind(checkbox1, 'checked', checkbox1_checked_binding));
	checkbox1.$on("focus", /*focus_handler_8*/ ctx[51]);

	return {
		c() {
			create_component(checkbox0.$$.fragment);
			t = space();
			create_component(checkbox1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(checkbox0, target, anchor);
			insert(target, t, anchor);
			mount_component(checkbox1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const checkbox0_changes = {};

			if (!updating_checked && dirty[0] & /*data*/ 524288) {
				updating_checked = true;
				checkbox0_changes.checked = /*data*/ ctx[19].solskjerming;
				add_flush_callback(() => updating_checked = false);
			}

			checkbox0.$set(checkbox0_changes);
			const checkbox1_changes = {};

			if (!updating_checked_1 && dirty[0] & /*data*/ 524288) {
				updating_checked_1 = true;
				checkbox1_changes.checked = /*data*/ ctx[19].garasjeport;
				add_flush_callback(() => updating_checked_1 = false);
			}

			checkbox1.$set(checkbox1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(checkbox0.$$.fragment, local);
			transition_in(checkbox1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(checkbox0.$$.fragment, local);
			transition_out(checkbox1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(checkbox0, detaching);
			if (detaching) detach(t);
			destroy_component(checkbox1, detaching);
		}
	};
}

// (309:16) {#if useDiscountCode}
function create_if_block_9(ctx) {
	let div1;
	let div0;

	let t_value = (/*data*/ ctx[19].discountCode
	? /*data*/ ctx[19].discountCode
	: 'Bruk rabattkode') + "";

	let t;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			t = text(t_value);
			set_style(div0, "cursor", "pointer");
			set_style(div0, "color", "#4183c4");
			set_style(div1, "padding-top", "0px");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, t);

			if (!mounted) {
				dispose = listen(div0, "click", /*click_handler*/ ctx[54]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*data*/ 524288 && t_value !== (t_value = (/*data*/ ctx[19].discountCode
			? /*data*/ ctx[19].discountCode
			: 'Bruk rabattkode') + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			dispose();
		}
	};
}

// (319:20) {#if saving}
function create_if_block_8(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sp sp-circle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (325:16) {#if formOnly === false}
function create_if_block_7(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.innerHTML = `*Ved innsending samtykker du til <a target="_blank" rel="noreferrer" href="https://www.kjellsmarkiser.no/personvern/">personvernerklæringen</a>`;
			set_style(div, "font-size", "12px");
			set_style(div, "padding-top", "4px");
			set_style(div, "text-align", "center");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (361:8) {:else}
function create_else_block_2(ctx) {
	let div;
	let inputfield;
	let current;

	let inputfield_props = {
		placeholder: "Rabattkode",
		name: "discountCode",
		required: false,
		autocomplete: "off",
		darkMode: false,
		icon: null,
		defaultValue: /*data*/ ctx[19].discountCode
	};

	inputfield = new InputField({ props: inputfield_props });
	/*inputfield_binding*/ ctx[63](inputfield);
	inputfield.$on("change", change_handler_5);
	inputfield.$on("keyup", /*keyup_handler*/ ctx[64]);
	inputfield.$on("focus", /*focus_handler_10*/ ctx[65]);

	return {
		c() {
			div = element("div");
			create_component(inputfield.$$.fragment);
			attr(div, "class", brand);
			set_style(div, "height", "110px");
			set_style(div, "width", "240px");
			set_style(div, "padding", "20px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(inputfield, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const inputfield_changes = {};
			if (dirty[0] & /*data*/ 524288) inputfield_changes.defaultValue = /*data*/ ctx[19].discountCode;
			inputfield.$set(inputfield_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inputfield.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inputfield.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			/*inputfield_binding*/ ctx[63](null);
			destroy_component(inputfield);
		}
	};
}

// (357:44) 
function create_if_block_5(ctx) {
	let div1;
	let div0;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			div0.textContent = "Koden er ugyldig eller utløpt";
			set_style(div0, "padding-top", "15px");
			attr(div1, "class", brand);
			set_style(div1, "height", "110px");
			set_style(div1, "width", "240px");
			set_style(div1, "padding", "20px");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

// (353:8) {#if discountCodeDetails}
function create_if_block_4(ctx) {
	let div1;
	let div0;
	let raw_value = /*discountCodeDetails*/ ctx[15].data.Terms + "";

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			attr(div1, "class", brand);
			set_style(div1, "padding", "20px");
			set_style(div1, "max-height", Math.ceil(/*innerHeight*/ ctx[18] * 0.8) - 110 + "px");
			set_style(div1, "overflow-y", "auto");
			set_style(div1, "padding-top", "20px");
			set_style(div1, "padding-bottom", "90px");
			set_style(div1, "width", "280px");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			div0.innerHTML = raw_value;
		},
		p(ctx, dirty) {
			if (dirty[0] & /*discountCodeDetails*/ 32768 && raw_value !== (raw_value = /*discountCodeDetails*/ ctx[15].data.Terms + "")) div0.innerHTML = raw_value;;

			if (dirty[0] & /*innerHeight*/ 262144) {
				set_style(div1, "max-height", Math.ceil(/*innerHeight*/ ctx[18] * 0.8) - 110 + "px");
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

// (334:0) <Dialog       bind:this={dialog}       className="{brand}"       style="{discountCodeDetails ? '' : 'margin-top: -60px;'}overflow:hidden;"       backdropStyle="border-radius:12px;"      on:open={(e) => {dispatch("dialogOpen", {name:"discountCode"})}}      on:close={(e) => {dispatch("dialogClose", {name:"discountCode"})}}  >
function create_default_slot(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block_4, create_if_block_5, create_else_block_2];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*discountCodeDetails*/ ctx[15]) return 0;
		if (/*discountCodeMatchNotFound*/ ctx[16]) return 1;
		return 2;
	}

	current_block_type_index = select_block_type_2(ctx, [-1, -1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			set_style(div, "margin-top", "40px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
		}
	};
}

// (347:8) {:else}
function create_else_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("RABATTKODE");
			attr(div, "class", brand);
			attr(div, "style", "");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (345:44) 
function create_if_block_3(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("UGYLDIG KODE");
			attr(div, "class", brand);
			attr(div, "style", "");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (343:8) {#if discountCodeDetails}
function create_if_block_2(ctx) {
	let div;
	let t_value = /*discountCodeDetails*/ ctx[15].data.Code + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			attr(div, "class", brand);
			attr(div, "style", "");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*discountCodeDetails*/ 32768 && t_value !== (t_value = /*discountCodeDetails*/ ctx[15].data.Code + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (342:4) 
function create_title_slot(ctx) {
	let div;

	function select_block_type_1(ctx, dirty) {
		if (/*discountCodeDetails*/ ctx[15]) return create_if_block_2;
		if (/*discountCodeMatchNotFound*/ ctx[16]) return create_if_block_3;
		return create_else_block_1;
	}

	let current_block_type = select_block_type_1(ctx, [-1, -1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "slot", "title");
			set_style(div, "width", "100%");
			set_style(div, "color", "white");
			set_style(div, "padding", "12px");
			set_style(div, "font-weight", "bold");
			set_style(div, "font-size", "0.9em");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

// (385:8) {:else}
function create_else_block(ctx) {
	let div;
	let button0;
	let t1;
	let button1;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button0 = element("button");
			button0.textContent = "AVBRYT";
			t1 = space();
			button1 = element("button");
			button1.textContent = "Bruk kode";
			set_style(button0, "width", "90px");
			set_style(button0, "height", "35px");
			set_style(button0, "background-color", "transparent");
			set_style(button0, "color", "black");
			set_style(button1, "width", "110px");
			set_style(button1, "height", "35px");
			attr(div, "class", brand);
			set_style(div, "display", "flex");
			set_style(div, "justify-content", "space-between");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button0);
			append(div, t1);
			append(div, button1);

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*click_handler_4*/ ctx[61]),
					listen(button1, "click", /*click_handler_5*/ ctx[62])
				];

				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (381:44) 
function create_if_block_1(ctx) {
	let div;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button = element("button");
			button.textContent = "OK";
			set_style(button, "width", "110px");
			set_style(button, "height", "35px");
			attr(div, "class", brand);
			set_style(div, "display", "flex");
			set_style(div, "justify-content", "right");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler_3*/ ctx[60]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (377:8) {#if discountCodeDetails}
function create_if_block(ctx) {
	let div;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button = element("button");
			button.textContent = "OK";
			set_style(button, "width", "110px");
			set_style(button, "height", "35px");
			attr(div, "class", brand);
			set_style(div, "display", "flex");
			set_style(div, "justify-content", "right");
			set_style(div, "padding", "10px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler_2*/ ctx[59]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (376:4) 
function create_bottom_right_slot(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if (/*discountCodeDetails*/ ctx[15]) return create_if_block;
		if (/*discountCodeMatchNotFound*/ ctx[16]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, [-1, -1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "slot", "bottom-right");
			set_style(div, "padding", "20px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let div_class_value;
	let t;
	let dialog_1;
	let current;
	let mounted;
	let dispose;
	add_render_callback(/*onwindowresize*/ ctx[28]);
	let if_block = /*data*/ ctx[19] && create_if_block_6(ctx);

	let dialog_1_props = {
		className: brand,
		style: "" + ((/*discountCodeDetails*/ ctx[15]
		? ''
		: 'margin-top: -60px;') + "overflow:hidden;"),
		backdropStyle: "border-radius:12px;",
		$$slots: {
			"bottom-right": [create_bottom_right_slot],
			title: [create_title_slot],
			default: [create_default_slot]
		},
		$$scope: { ctx }
	};

	dialog_1 = new Dialog({ props: dialog_1_props });
	/*dialog_1_binding*/ ctx[66](dialog_1);
	dialog_1.$on("open", /*open_handler*/ ctx[67]);
	dialog_1.$on("close", /*close_handler*/ ctx[68]);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			create_component(dialog_1.$$.fragment);
			attr(div, "class", div_class_value = "leadscontainer " + brand);
			set_style(div, "max-height", /*innerHeight*/ ctx[18] + "px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			insert(target, t, anchor);
			mount_component(dialog_1, target, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(window, "resize", /*onwindowresize*/ ctx[28]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*data*/ ctx[19]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty[0] & /*data*/ 524288) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_6(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, null);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (!current || dirty[0] & /*innerHeight*/ 262144) {
				set_style(div, "max-height", /*innerHeight*/ ctx[18] + "px");
			}

			const dialog_1_changes = {};

			if (dirty[0] & /*discountCodeDetails*/ 32768) dialog_1_changes.style = "" + ((/*discountCodeDetails*/ ctx[15]
			? ''
			: 'margin-top: -60px;') + "overflow:hidden;");

			if (dirty[0] & /*discountCodeDetails, discountCodeMatchNotFound, dialog, innerHeight, data, discountCodeCtrl*/ 909312 | dirty[2] & /*$$scope*/ 1024) {
				dialog_1_changes.$$scope = { dirty, ctx };
			}

			dialog_1.$set(dialog_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(dialog_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(dialog_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (detaching) detach(t);
			/*dialog_1_binding*/ ctx[66](null);
			destroy_component(dialog_1, detaching);
			mounted = false;
			dispose();
		}
	};
}

let brand = "kjells";
let brandName = "Kjells markiser";
let useDiscountCode = true;

const change_handler_5 = e => {
	
};

function instance($$self, $$props, $$invalidate) {
	let { fbApp } = $$props;
	let { products = "Solskjerming,Garasjeport" } = $$props;
	let { formOnly = false } = $$props;
	let { saving = false } = $$props;
	let { noServiceLink = false } = $$props;
	let form;
	let nameCtrl, addressCtrl, postalCodeCtrl, telCtrl, emailCtrl, messageCtrl;
	let privateInput, companyInput;
	let dialog, discountCodeCtrl;
	let discountCodeDetails = null;
	let discountCodeMatchNotFound = false;
	let formHeight;
	let innerHeight;

	let data = {
		solskjerming: true,
		garasjeport: false,
		segment: "privat",
		name: "",
		address: "",
		postalCode: "",
		email: "",
		phoneNo: "",
		message: "",
		brand,
		discountCode: null
	};

	let dispatch = createEventDispatcher();

	const debounceChange = _.debounce(
		() => {
			let formItems = {};
			formItems.name = nameCtrl.getValue();
			formItems.address = addressCtrl.getValue();
			formItems.postalCode = postalCodeCtrl.getValue();
			formItems.phoneNo = telCtrl.getValue();
			formItems.email = emailCtrl.getValue();
			formItems.message = messageCtrl.getValue();
			formItems.solskjerming = data.solskjerming;
			formItems.garasjeport = data.garasjeport;
			formItems.segment = data.segment;
			dispatch("changed", formItems);
		},
		1000,
		{ 'leading': false, 'trailing': true }
	);

	function onSubmit() {
		if (form.checkValidity()) {
			$$invalidate(19, data.name = nameCtrl.getValue(), data);
			$$invalidate(19, data.address = addressCtrl.getValue(), data);
			$$invalidate(19, data.postalCode = postalCodeCtrl.getValue(), data);
			$$invalidate(19, data.phoneNo = telCtrl.getValue(), data);
			$$invalidate(19, data.email = emailCtrl.getValue(), data);
			$$invalidate(19, data.message = messageCtrl.getValue(), data);
			dispatch("submit", data);
		} else {
			form.reportValidity();
		}
	}

	function clearLonLat() {
		if (data.longitude) {
			delete data.longitude;
		}

		if (data.latitude) {
			delete data.latitude;
		}
	}

	function onAddressChange(e) {
		clearLonLat();

		//console.log("onAddressChange", e, data.address);
		$$invalidate(19, data.address = e.target.value, data);

		if (data.address) {
			let r = /\d+/;
			let match = data.address.match(r);

			//console.log(match);
			if (match && match.length > 0) {
				//console.log(match.index);
				if (match.index > 0) {
					//console.log(data.address[match.index-1]);
					if (data.address[match.index - 1] !== ' ') {
						$$invalidate(19, data.address = data.address.slice(0, match.index) + " " + data.address.slice(match.index), data);
					}
				}
			}
		}

		if (data.address && data.postalCode) {
			getAddressLonLat();
		}
	}

	function onPostalCodeChange(e) {
		clearLonLat();
		$$invalidate(19, data.postalInfo = null, data);

		//console.log("onPostalCodeChange", e);
		$$invalidate(19, data.postalCode = e.target.value, data);

		if (!isNaN(e.target.value)) {
			getPostalInfo(e.target.value);
		}
	}

	function getPostalInfo(postalCode) {
		let postalCodeValue = parseInt(postalCode);

		//console.log("getPostalInfo", postalCode, data);
		getDoc(doc(getFirestore(fbApp), "/datasets/open/PostalCodes", '' + postalCodeValue)).then(response => {
			let postalCode = response.data();

			if (postalCode) {
				$$invalidate(19, data.postalInfo = postalCode, data);
			}
		}).catch(err => {
			console.log("Error", err);
		});

		if (data.address) {
			getAddressLonLat();
		}
	}

	function getAddressLonLat() {
		let address = encodeURI(data.address);

		//console.log("getAddressLonLat", data.address, data.postalCode);
		let url = "https://ws.geonorge.no/adresser/v1/sok?adressetekst=" + address + "&postnummer=" + data.postalCode + "&treffPerSide=10&side=0&asciiKompatibel=true";

		//console.log(url);
		axios.get(url).then(result => {
			//console.log("getAddressLonLat", result);
			if (result.data.adresser.length > 0) {
				let addresse = result.data.adresser[0];

				//console.log(addresse);
				$$invalidate(19, data.latitude = addresse.representasjonspunkt.lat, data);

				$$invalidate(19, data.longitude = addresse.representasjonspunkt.lon, data);

				dispatch("geolocation", {
					longitude: data.longitude,
					latitude: data.latitude
				});
			} else {
				dispatch("geolocation", { longitude: null, latitude: null });
			}
		});
	}

	function onUseCode() {
		//console.log("onUseCode", discountCodeCtrl.getValue(), discountCodes);
		$$invalidate(16, discountCodeMatchNotFound = false);

		$$invalidate(15, discountCodeDetails = null);

		if (discountCodeCtrl.getValue() && discountCodeCtrl.getValue() !== "") {
			let codeFilter = [];
			codeFilter.push(discountCodeCtrl.getValue());
			codeFilter.push(discountCodeCtrl.getValue().toUpperCase());
			let query = fsQuery(collection(getFirestore(fbApp), "/market/data/DiscountCodes"), fsWhere("Code", "in", codeFilter));

			getDocs(query).then(response => {
				//console.log("RESPONSE", response);
				if (response && response.docs && response.docs.length > 0) {
					try {
						let docData = response.docs[0].data();
						let brandAccess = brand.charAt(0).toUpperCase() + brand.slice(1);

						//console.log("docData", docData, brandAccess, docData[brandAccess]);
						if (docData[brandAccess] && docData[brandAccess].toUpperCase() === 'X') {
							let dt = new Date();

							if (dt >= new Date(docData.ValidFrom) && dt <= new Date(docData.ValidTo)) {
								$$invalidate(15, discountCodeDetails = { id: docData.Id, data: docData });
								$$invalidate(15, discountCodeDetails.data.Terms = discountCodeDetails.data.Terms.replace("{{brand}}", brandName), discountCodeDetails);
							}
						}
					} catch(ex) {
						
					}
				}

				if (!discountCodeDetails) {
					$$invalidate(16, discountCodeMatchNotFound = true);
				}
			}).catch(err => {
				console.log("Error in Get DiscountCodes", err); //console.log("discountCodeDetails", discountCodeDetails);
			});
		}
	}

	function onConfirmDiscountCode() {
		//console.log("onConfirmDiscountCode");
		$$invalidate(19, data.discountCode = discountCodeDetails.data.Code.toUpperCase(), data);

		dispatch('discountCodeSelected', discountCodeDetails);
		$$invalidate(15, discountCodeDetails = null);
		dialog.close();
	}

	onMount(() => {
		if (products && (products.indexOf("Solskjerming") === -1 || products.indexOf("Garasjeport") === -1)) {
			$$invalidate(19, data.solskjerming = products.indexOf("Solskjerming") > -1, data);
			$$invalidate(19, data.garasjeport = products.indexOf("Garasjeport") > -1, data);
		}

		setTimeout(
			() => {
				if (privateInput) {
					if (privateInput.checked) {
						$$invalidate(19, data.segment = "privat", data);
					}
				}

				if (companyInput) {
					if (companyInput.checked) {
						$$invalidate(19, data.segment = "bedrift", data);
					}
				}

				$$invalidate(19, data.name = nameCtrl.getValue(), data);
				$$invalidate(19, data.address = addressCtrl.getValue(), data);
				$$invalidate(19, data.postalCode = postalCodeCtrl.getValue(), data);
				$$invalidate(19, data.phoneNo = telCtrl.getValue(), data);
				$$invalidate(19, data.email = emailCtrl.getValue(), data);
				$$invalidate(19, data.message = messageCtrl.getValue(), data);

				if (discountCodeCtrl) {
					$$invalidate(19, data.discountCode = discountCodeCtrl.getValue(), data);
				}

				if (data.postalCode) {
					getPostalInfo(data.postalCode);
				}
			},
			400
		);
	});

	function onwindowresize() {
		$$invalidate(18, innerHeight = window.innerHeight)
	}

	const change_handler = e => {
		$$invalidate(19, data.segment = e.currentTarget.value, data);
	};

	function input0_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			privateInput = $$value;
			$$invalidate(11, privateInput);
		});
	}

	const focus_handler = e => dispatch("focus", { field: 'privat' });

	const change_handler_1 = e => {
		$$invalidate(19, data.segment = e.currentTarget.value, data);
	};

	function input1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			companyInput = $$value;
			$$invalidate(12, companyInput);
		});
	}

	const focus_handler_1 = e => dispatch("focus", { field: 'privat' });

	function inputfield0_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			nameCtrl = $$value;
			$$invalidate(5, nameCtrl);
		});
	}

	const focus_handler_2 = e => dispatch("focus", e.detail);

	function inputfield1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			addressCtrl = $$value;
			$$invalidate(6, addressCtrl);
		});
	}

	const change_handler_2 = e => {
		onAddressChange(e.detail);
	};

	const focus_handler_3 = e => dispatch("focus", e.detail);

	function inputfield2_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			postalCodeCtrl = $$value;
			$$invalidate(7, postalCodeCtrl);
		});
	}

	const change_handler_3 = e => {
		onPostalCodeChange(e.detail);
	};

	const focus_handler_4 = e => dispatch("focus", e.detail);

	function inputfield3_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			telCtrl = $$value;
			$$invalidate(8, telCtrl);
		});
	}

	const change_handler_4 = e => {
		console.log("Tel changed", e.detail);
	};

	const focus_handler_5 = e => dispatch("focus", e.detail);

	function inputfield4_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			emailCtrl = $$value;
			$$invalidate(9, emailCtrl);
		});
	}

	const focus_handler_6 = e => dispatch("focus", e.detail);

	function checkbox0_checked_binding(value) {
		if ($$self.$$.not_equal(data.solskjerming, value)) {
			data.solskjerming = value;
			$$invalidate(19, data);
		}
	}

	const focus_handler_7 = e => dispatch("focus", e.detail);

	function checkbox1_checked_binding(value) {
		if ($$self.$$.not_equal(data.garasjeport, value)) {
			data.garasjeport = value;
			$$invalidate(19, data);
		}
	}

	const focus_handler_8 = e => dispatch("focus", e.detail);

	function inputfield5_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			messageCtrl = $$value;
			$$invalidate(10, messageCtrl);
		});
	}

	const focus_handler_9 = e => dispatch("focus", e.detail);

	const click_handler = e => {
		dialog.open();
	};

	function form_1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			form = $$value;
			$$invalidate(4, form);
		});
	}

	function form_1_elementresize_handler() {
		formHeight = this.clientHeight;
		$$invalidate(17, formHeight);
	}

	const input_handler = e => {
		debounceChange();
	};

	const click_handler_1 = e => {
		onSubmit(e);
	};

	const click_handler_2 = () => {
		onConfirmDiscountCode();
	};

	const click_handler_3 = () => {
		$$invalidate(16, discountCodeMatchNotFound = false);
		dialog.close();
	};

	const click_handler_4 = () => {
		dialog.close();
	};

	const click_handler_5 = () => {
		onUseCode();
	};

	function inputfield_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			discountCodeCtrl = $$value;
			$$invalidate(14, discountCodeCtrl);
		});
	}

	const keyup_handler = e => {
		if (e.detail.keyCode === 13) {
			onUseCode();
		}
	};

	const focus_handler_10 = e => dispatch("focus", e.detail);

	function dialog_1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			dialog = $$value;
			$$invalidate(13, dialog);
		});
	}

	const open_handler = e => {
		dispatch("dialogOpen", { name: "discountCode" });
	};

	const close_handler = e => {
		dispatch("dialogClose", { name: "discountCode" });
	};

	$$self.$$set = $$props => {
		if ('fbApp' in $$props) $$invalidate(27, fbApp = $$props.fbApp);
		if ('products' in $$props) $$invalidate(0, products = $$props.products);
		if ('formOnly' in $$props) $$invalidate(1, formOnly = $$props.formOnly);
		if ('saving' in $$props) $$invalidate(2, saving = $$props.saving);
		if ('noServiceLink' in $$props) $$invalidate(3, noServiceLink = $$props.noServiceLink);
	};

	return [
		products,
		formOnly,
		saving,
		noServiceLink,
		form,
		nameCtrl,
		addressCtrl,
		postalCodeCtrl,
		telCtrl,
		emailCtrl,
		messageCtrl,
		privateInput,
		companyInput,
		dialog,
		discountCodeCtrl,
		discountCodeDetails,
		discountCodeMatchNotFound,
		formHeight,
		innerHeight,
		data,
		dispatch,
		debounceChange,
		onSubmit,
		onAddressChange,
		onPostalCodeChange,
		onUseCode,
		onConfirmDiscountCode,
		fbApp,
		onwindowresize,
		change_handler,
		input0_binding,
		focus_handler,
		change_handler_1,
		input1_binding,
		focus_handler_1,
		inputfield0_binding,
		focus_handler_2,
		inputfield1_binding,
		change_handler_2,
		focus_handler_3,
		inputfield2_binding,
		change_handler_3,
		focus_handler_4,
		inputfield3_binding,
		change_handler_4,
		focus_handler_5,
		inputfield4_binding,
		focus_handler_6,
		checkbox0_checked_binding,
		focus_handler_7,
		checkbox1_checked_binding,
		focus_handler_8,
		inputfield5_binding,
		focus_handler_9,
		click_handler,
		form_1_binding,
		form_1_elementresize_handler,
		input_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		inputfield_binding,
		keyup_handler,
		focus_handler_10,
		dialog_1_binding,
		open_handler,
		close_handler
	];
}

class Kjells extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				fbApp: 27,
				products: 0,
				formOnly: 1,
				saving: 2,
				noServiceLink: 3
			},
			null,
			[-1, -1, -1]
		);
	}
}

export default Kjells;